import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { KameleoonService } from './kameleoon.service';

export function kameleoonInitializerFn(): void | Observable<unknown> | Promise<unknown> {
    const gtm = inject(KameleoonService);
    return gtm.init();
}
